import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function ProtectedRoute({ component: Component, path, ...rest }) {
  const isAuthenticated = !!localStorage.getItem('accessToken'); // Check if user is authenticated

  return (
    <Route
      {...rest}
      render={(props) => {
        if (path.startsWith('/app') && !isAuthenticated) {
          // Redirect to login if trying to access protected routes without authentication
          return <Redirect to="/" />;
        }

        // Allow access to public routes or protected routes if authenticated
        return <Component {...props} />;
      }}
    />
  );
}

export default ProtectedRoute;
